// Libraries
import 'bootstrap';

// Global components
import './Components/MainNavigationClass';
import './Components/ScrollToClass';
import './Components/ToTopButtonClass';
import './Components/SliderClass';
import './Components/LightboxClass';
import './Components/LightboxContentClass';
import './Components/ImageGalleryClass';
import './Components/TopicQuiz';
import './Components/FrequencyFinderClass';
import './Components/TextmediaImageClass';
import './Components/MultiSelectClass';
import './Components/AccordionClass';
import './Components/PopoverClass';
import './Components/SearchListClass';
import {ImagePreview} from './Components/ImagePreviewClass'
import {Popover} from "./Components/PopoverClass";
import {Accordion} from "./Components/AccordionClass";
import {AutoReload} from "./Components/AutoReloadClass";
import {ButtonReload} from "./Components/ButtonReloadClass";

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-popover]').forEach(el => {
        new Popover(el);
    });

    document.querySelectorAll<HTMLElement>('[data-image-overlay]').forEach(el => {
        new ImagePreview(el);
    });

    document.querySelectorAll<HTMLElement>('[data-accordion]').forEach(accordion => {
        new Accordion(accordion);
    });

    document.querySelectorAll<HTMLInputElement>('[data-auto-reload]').forEach(reloadAuto => {
        new AutoReload(reloadAuto);
    });
    document.querySelectorAll<HTMLElement>('[data-button-reload]').forEach(reloadButton => {
        new ButtonReload(reloadButton);
    });

    document.querySelectorAll<HTMLElement>('.privacymanager').forEach(trigger => {
        trigger.addEventListener('click', function(event){
            event.preventDefault();
            // @ts-ignore
            if (window.UC_UI instanceof Object) {
                // @ts-ignore
                window.UC_UI.showFirstLayer();
            } else {
                console.error('window.UC_UI not loaded!');
            }
            return false;
        });
    })
    document.querySelectorAll<HTMLElement>('#page-1051, #page-9, #page-1052, #page-1441, #page-1053, #page-1048, #page-7').forEach(trigger => {
        let attempts = 0;
        const maxAttempts = 100;

        const interval = setInterval(() => {
                // @ts-ignore
                if (window.UC_UI instanceof Object && window.UC_UI.isInitialized() === true)
                {
                    // @ts-ignore
                    window.UC_UI.closeCMP();
                    clearInterval(interval); // Stop polling once it’s available
                } else if (++attempts >= maxAttempts) {
                    clearInterval(interval); // Stop after max attempts
                }
            },
            100);
    })


});
